export default "__VITE_ASSET__1OWFgD6K__"